import "fullpage.js";

$(function() {
    // fullpage
    const $fullpage = $('[data-js="fullpage"]'),
        $fullpageSlides = $fullpage.find('[data-js="fullpage__slide"]'),
        $logo = $('[data-js="logo"]'),
        $regBtn = $('[data-js~="reg-btn"]'),
        $window = $(window),
        $siteImg = $('[data-js="site__img"]');
    // console.log($('[data-js="site__img"]'));

    $window.on("orientationchange", () => {
        $window.trigger("resize");
    });

    $fullpage.fullpage({
        sectionSelector: '[data-js="fullpage__slide"]',
        navigation: true,
        slidesNavigation: true,
        controlArrows: false,
        verticalCentered: false,
        continuousVertical: true,
        normalScrollElements: '[data-js="page__side"], [data-js="site__text"], [data-js~="popup"]',
        normalScrollElementTouchThreshold: 10,
        onLeave: function(index, nextIndex, direction) {
            // $window.trigger("resize");
            const currentTheme = $fullpageSlides
                .eq(nextIndex - 1)
                .data("theme");

            $regBtn
                .removeClass("btn--primary btn--secondary btn--tertiary btn--quaternary")
                .addClass("btn--" + currentTheme);

            if ((nextIndex - 1) % 2 !== 0) {
                $logo
                    .removeClass("site__logo--primary")
                    .addClass("site__logo--secondary");
            } else {
                $logo
                    .removeClass("site__logo--secondary")
                    .addClass("site__logo--primary");
            }

            $(window).scrollTop(-1);

        },
    });
  });



// WEBPACK FOOTER //
// ./static/components/Fullpage.js